import { create } from "zustand";
import { produce } from "immer";

export const useMenu = create((set) => ({
  data: {
    open: true,
    size: "16rem",
    itens: {},

  },
  actions: {
    toggleSize: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.open = !state.data.open
          draft.data.size = state.data.open ? "4.5rem" : "16rem"
        })
      ),
    setItem: (item) =>
      set((state) =>
        produce(state, (draft) => {
          if (!item.name) return
          if (!!state.data.itens[item.name]) return
          draft.data.itens[item.name] = {
            name: item.name,
            open: item.open || false,
            active: item.active || false,
            submenu: item.submenu || false,
          };
          state.data.itens[item.name]
        })
      ),
    /**
     * Abre um item e FECHA os outros. Com o menu recolhido cada submenu aberto
     * vira uma caixa flutuante em `left-full top-0`: dois abertos ao mesmo
     * tempo caem exatamente no mesmo lugar e ficam um por cima do outro,
     * ilegiveis. Comportamento de sanfona resolve e tambem deixa o menu
     * aberto mais previsivel.
     */
    toggleItem: (name) =>
      set((state) =>
        produce(state, (draft) => {
          if (!state.data.itens[name]) return

          const vaiAbrir = !state.data.itens[name].open

          Object.keys(state.data.itens).forEach((chave) => {
            draft.data.itens[chave].open = chave === name ? vaiAbrir : false
          })
        })
      ),
    /** Fecha todos os submenus — usado ao escolher um item ou sair do menu. */
    closeItems: () =>
      set((state) =>
        produce(state, (draft) => {
          Object.keys(state.data.itens).forEach((chave) => {
            draft.data.itens[chave].open = false
          })
        })
      ),
    setActive: (name) =>
      set((state) =>
        produce(state, (draft) => {
          if (!state.data.itens[name]) return
          if (state.data.itens[name].active) return

          Object.keys(state.data.itens).forEach((key) => {
            if (key !== name) draft.data.itens[key].active = false
            if (key === name) draft.data.itens[key].active = true
          })
        })
      ),
  },
}));
